import classNames from "classnames";
import { BoxItem } from "./box_item";
import { Disabler } from "./disabler";

export function SelectableBox(props: {
	className?: string;
	children: React.ReactNode;
	disabled?: boolean;
	bgColor: "semidark" | "dark";
	onClick?: () => void;
	force_hover?: boolean;
}) {
	const { children, disabled, onClick } = props;

	return (
		<Disabler disabled={props.disabled}>
			<BoxItem
				bgColor={props.bgColor}
				className={classNames(
					"cursor-pointer hover:border-sesh-primary",
					{
						"border-sesh-primary": props.force_hover,
					},
					props.className
				)}
				onClick={() => {
					if (disabled) {
						return;
					}
					onClick?.();
				}}
			>
				{children}
			</BoxItem>
		</Disabler>
	);
}
